export const placeList = {
    HCM: [
        '78-80-82 Hoàng Hoa Thám, P.12, Q.Tân Bình, TP.HCM',
        '905 Kha Vạn Cân, P. Linh Tây, TP. Thủ Đức',
        '1081-1083 Trần Hưng Đạo, P.5, Q.5, TP.HCM',
        '63 Nguyễn Cửu Vân, P.17, Q.Bình Thạnh, TP.HCM',
    ],
    HN: [
        '162-164 Thái Hà, P. Trung Liệt, Q.Đống Đa, Hà Nội'
    ]
}

    
    
